import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone, MapPin } from 'lucide-react';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Footer = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API_URL}/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error('Failed to fetch settings:', error);
    }
  };

  const formatPhone = (phone) => {
    if (!phone) return '';
    const numbers = phone.replace(/\D/g, '');
    if (numbers.length === 11) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
    }
    if (numbers.length === 13) {
      return `(${numbers.slice(2, 4)}) ${numbers.slice(4, 9)}-${numbers.slice(9)}`;
    }
    return phone;
  };

  return (
    <footer data-testid="footer" className="relative bg-primary text-white noise-texture">
      <div className="px-6 md:px-12 lg:px-24 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Logo e Tagline */}
          <div>
            <img 
              src={settings?.logo_light_image || "https://customer-assets.emergentagent.com/job_loja-digital-56/artifacts/sij1t4lp_PEQUENA_BRANCA.png"} 
              alt="casa in gold by Fhiama Fonseca" 
              className="h-24 w-auto mb-4"
            />
            <p className="text-sm font-light leading-relaxed text-white/70">
              {settings?.about_tagline || 'Criando espaços extraordinários com móveis de alto padrão desde 2010.'}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-accent text-xs uppercase tracking-widest mb-4">Links</h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/catalogo"
                className="text-sm font-light text-white/70 hover:text-white transition-colors duration-300"
              >
                Catálogo
              </Link>
              <Link
                to="/sobre"
                className="text-sm font-light text-white/70 hover:text-white transition-colors duration-300"
              >
                Sobre
              </Link>
              <Link
                to="/contato"
                className="text-sm font-light text-white/70 hover:text-white transition-colors duration-300"
              >
                Contato
              </Link>
            </div>
          </div>

          {/* Contato */}
          <div>
            <h4 className="font-accent text-xs uppercase tracking-widest mb-4">Contato</h4>
            <div className="flex flex-col gap-3">
              {settings?.contact_phone && (
                <a 
                  href={`https://wa.me/${settings?.contact_whatsapp || settings?.contact_phone?.replace(/\D/g, '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm font-light text-white/70 hover:text-white transition-colors"
                >
                  <Phone className="w-4 h-4" strokeWidth={1.5} />
                  {formatPhone(settings.contact_phone)}
                </a>
              )}
              {settings?.contact_email && (
                <a 
                  href={`mailto:${settings.contact_email}`}
                  className="flex items-center gap-2 text-sm font-light text-white/70 hover:text-white transition-colors"
                >
                  <Mail className="w-4 h-4" strokeWidth={1.5} />
                  {settings.contact_email}
                </a>
              )}
              {settings?.contact_address && (
                <div className="flex items-start gap-2 text-sm font-light text-white/70">
                  <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                  <span className="whitespace-pre-line">{settings.contact_address}</span>
                </div>
              )}
            </div>
          </div>

          {/* Horário e Redes Sociais */}
          <div>
            <h4 className="font-accent text-xs uppercase tracking-widest mb-4">Atendimento</h4>
            <p className="text-sm font-light text-white/70 mb-4">
              {settings?.hours_weekday || 'Segunda a Sexta: 9h às 18h'}<br />
              {settings?.hours_weekend || 'Sábado: 8h às 12h'}
            </p>
            
            <h4 className="font-accent text-xs uppercase tracking-widest mb-3 mt-6">Siga-nos</h4>
            <div className="flex gap-3">
              {settings?.social_instagram && (
                <a
                  href={settings.social_instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="w-9 h-9 border border-white/20 flex items-center justify-center hover:bg-white hover:text-primary transition-all duration-500"
                >
                  <Instagram className="w-4 h-4" strokeWidth={1.5} />
                </a>
              )}
              {settings?.contact_email && (
                <a
                  href={`mailto:${settings.contact_email}`}
                  data-testid="footer-email"
                  className="w-9 h-9 border border-white/20 flex items-center justify-center hover:bg-white hover:text-primary transition-all duration-500"
                >
                  <Mail className="w-4 h-4" strokeWidth={1.5} />
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10">
          <p className="text-xs text-white/50 font-light">
            © 2024 casa in gold by Fhiama Fonseca. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
